import { path } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const getBranchKey = (state, brandRoute, shopId) => (
  path(['extensions', 'byRoute', brandRoute, 'branchKey'], state) ||
  path(['extensions', 'byShopId', shopId, 'branchKey'], state) ||
  path(['extensions', 'byId', shopId, 'branchKey'], state)
);



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/selectors.js